const LocalStorageConstant: any = {
    accessToken: "access_token",
    refreshToken: "refresh_token",
    user: "user_data",
};

export default LocalStorageConstant;
